import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { fetchAllMembers } from '../../actions/Member';

const $ = window.$;

class Members extends Component {

    componentDidMount() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });

        // $('#members-list').DataTable({
        //     searching: false,
        //     info: false,
        //     language: {
        //         "sDom": 'Rfrtlip',
        //         "lengthMenu": "Display _MENU_ Entries",
        //         paginate: {
        //             previous: '<<',
        //             next: '>>',
        //         }
        //     },
        //     "dom": '<"top"f>rt<"bottom"ilp><"clear">',
        //     fixedColumns: true,
        //     bAutoWidth: false,
        //     columnDefs: [{
        //         width: 200,
        //         targets: 0
        //     },
        //     {
        //         width: 200,
        //         targets: 1
        //     },
        //     {
        //         width: 250,
        //         targets: 2
        //     },
        //     {
        //         width: 20,
        //         targets: 2
        //     }
        //     ],
        // });

        this.props.fetchAllMembers();
    }

    onClickDelete(member) {

    }

    renderMembers() {
        const { members } = this.props;

        const rows = _.map(members, (member, key) => {
            return (
                <tr key={key}>
                    <td>{member.name}</td>
                    <td>{member.email}</td>
                    <td>{member.phone}</td>
                    <td>
                        <button 
                            className="btn btn-tooltip" 
                            data-toggle="tooltip" 
                            data-placement="top" 
                            title="Delete"
                            onClick={() => this.onClickDelete(member)}
                        >
                            <img src="/resources/img/ic-delete.png" alt="Delete" />
                        </button>
                    </td>
                </tr>
            );
        });

        return (
            <tbody>
                {rows}
            </tbody>
        )
    }

    renderActions(member) {
        return (
            <div>
                <button
                    className="btn btn-tooltip"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                    onClick={() => this.onClickDelete(member)}
                >
                    <img src="/resources/img/ic-delete.png" alt="Delete" />
                </button>
            </div>
        );
    }

    memberEmail(member) {

        if (member.email) {
            return member.email;
        }
        if (member.providerData) {
            return member.providerData[0].email;
        }
        return '-';
    }

    renderTable() {
        const { members } = this.props;

        console.log(members);

        const data = _.toArray(members);

        return (
            <ReactTable
                data={data}
                columns={[
                    {
                        Header: 'Name',
                        id: 'name',
                        accessor: d => d.displayName
                    },
                    {
                        Header: 'Email',
                        id: 'email',
                        accessor: d => this.memberEmail(d),
                        width: 300
                    },
                    {
                        Header: 'Phone',
                        id: 'phone',
                        accessor: d => d.phone ? d.phone : '-',
                        width: 200
                    }, 
                    {
                        Header: '',
                        id: 'actionButton',
                        className: 'col-center',
                        accessor: d => this.renderActions(d),
                        width: 40
                    }
                ]}
                defaultPageSize={10}
                className="-highlight"
            />
        );
    }

    render() {
        return (
            <div className="main-content">
                <div className="page-title">Members</div>
                <div className="divider"></div>
                <div className="function members">
                    <div className="row">
                        <div className="col-12">
                            <div className="input-group search-box">
                                <input type="text" className="form-control" placeholder="Search..." name="search-box" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderTable()}
                {/* <table id="members-list" className="table table-list" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Account / Email</th>
                            <th>Phone</th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.renderMembers()}
                </table> */}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { members } = state.member;
    return { members };
}

export default connect(mapStateToProps, { 
    fetchAllMembers 
})(Members);


// WEBPACK FOOTER //
// ./src/views/members/index.js